// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"d5d3298a","435":"18b176b0","583":"6617b8ab","845":"68556b27","983":"b521ed83"}[chunkId] + ".chunk.js";
};